module.exports = __webpack_public_path__ + "8263aa560b524740aaae3c78a35881f2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/dog.svg
// module id = 84
// module chunks = 0